<template>
  <div class="withdraw-container">
    <h2>{{$t('newLiveAccount.title')}}</h2>
    <!-- Platforms -->
    <CustomSelector v-model="platforms" :placeholder="this.$t('newLiveAccount.platform')" :options="listPlatforms"></CustomSelector>
    <!-- Platforms -->
    <CustomSelector v-model="currencys" :placeholder="this.$t('newLiveAccount.currency')" :options="currencyType"></CustomSelector>

    <button class="red-button" @click="bodybuild">{{$t('newLiveAccount.account')}}</button>
    <button class="cabinet-back" @click="back">
      <div class="icon"></div>{{$t('newLiveAccount.back')}}
    </button>

    <transition>
      <div v-if="showmodalSuccess" class="modal-mask">
        <div class="modalSuccess">
          <div class="infoDemo">
            <img class="imgcheck" src="/assets/images/green_check.svg" alt />
            <h2>{{$t('newLiveAccount.congratulation')}}</h2>
            <p class="description">{{$t('newLiveAccount.text')}}</p>
            <button @click="closeModal()">{{$t('newLiveAccount.close')}}</button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import CustomSelector from "@/components/CustomSelector";
import { getCurrentInstance, onMounted, onUnmounted, ref } from "@vue/runtime-core";
import axios from "axios";
import store from "@/store"
import { PLATFORMS_LIVE_ACCOUNT, CURRENCY_LIVE_ACCOUNT } from "../../plugins/countries";
import router from "../../router";

export default {
  name: "NewLiveAccount",
  components: {
    CustomSelector
  },
  setup() {
    let platforms = ref(0)
    let listPlatforms = ref(PLATFORMS_LIVE_ACCOUNT)
    let currencys = ref(0)
    let currencyType = ref(CURRENCY_LIVE_ACCOUNT)
    let showmodalSuccess = ref(false)

    let showM = ref(false)

    const internalInstance = getCurrentInstance()
    const emitter = internalInstance.appContext.config.globalProperties.emitter

    let userInfo

    onMounted(() => {
      window.addEventListener('keydown', reset)

      emitter.on('userUpdated', () => {
        load()
      })
      
      load()
    })

    onUnmounted(() => {
      window.removeEventListener('keydown', reset)
      emitter.off('userUpdated')
    })

    const changed = (e) => {
      // console.log(currency)
      console.log(e)
    }

    /***Validaciones Send****/
    const validationsSend = () => {
      let valid = ''
      let flag = 0

      let required = [
        platforms.value,
        currencys.value,
      ]

      for (let i = 0; i < required.length; i++) {
        if (required[i] === undefined || required[i] === null || required[i] === '' || required[i] === 0) {
          valid = false
        } else {
          valid = true
        }
      }

      /// validación campos no vacios
      if (!valid) {
        emitter.emit('showDialog', this.$t('newLiveAccount.text'))
        flag = 1
        return false
      } else {
        flag = 0
      }

      return flag
    }

    const closeModal = () => {
      showmodalSuccess = false
      router.push({
        path: '/cabinet/console/accounts'
      })
    }


    /******Body petición withdraw******/
    const bodybuild = () => {
      let validate = validationsSend()
      if (validate === 0) {
        withdraw({
          "platform": platforms.value,
          "account_type": 'individual',
          "currency": currencys.value
        })
      }
    }

    const withdraw = (_body) => {
      showM.value = true

      let _headers = {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + store.state.token,
        'X-Api-Key': process.env.VUE_APP_X_API_KEY
      }

      let _url = process.env.VUE_APP_CABINET_V2_API_HOST_ACCOUNTS + '/account_live '
      // eslint-disable-next-line no-unused-vars
      axios({ method: 'POST', url: _url, data: _body, headers: _headers }).then((result) => {
        result = result.data
        // router.push({
        //   path: '/cabinet/console/accounts'
        // })
        showM.value = false
        showmodalSuccess.value = true

      }).catch((error) => {
        showM.value = false
        let error1 = ""
        let error2 = ""
        error1 = error.response.data.message
        error2 = error.response.data.response.message
        emitter.emit('showDialog', error1 + ' / '+ error2)
      })
    }

    const back = () => {
      router.go(-1)
    }

    const reset = (e) => {
      if (e.key === 'Escape') {
        platforms.value = null
        currencys.value = null
      }
    }

    const load = () => {
      if (!store.state.user) {
        return
      }

      accessPermit()
      userInfo = store.state.user
    }

    const accessPermit = () => {
      console.log(store.state.user);
      if (store.state.user.registerStatus != 'ACTIVE') {
        router.push({
          path: '/cabinet/console/applications'
        })
      }
    }

    return {
      platforms,
      listPlatforms,
      currencys,
      currencyType,
      showmodalSuccess,

      back,
      changed,
      withdraw,
      reset,
      bodybuild,
      validationsSend,
      accessPermit,
      closeModal,

      showM
    }
  }
}
</script>

<style scoped>
</style>
